import MultiUserToClientModalPicker from "components/Picker/UserToClientPicker/MultiUserToClientModalPicker";
import Table from "components/Tables/Table";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { UserAvatar } from "../../components/Atoms/Avatar";
import { ButtonSecondary } from "components/Atoms/Button";

interface UserListProps {
  environment: server.dto.Environments
  userToClients: server.dto.UserToClientSmall[]
  onUsersChanged: (newUsers: server.dto.UserToClientSmall[]) => void
  freeFieldProfileId: number
}

const userDetailPage = (environment: server.dto.Environments, userToClientId: number) => {
  if (environment === "internal") {
    return routes.internalUser_Detail(userToClientId).absolute;
  } else {
    return routes.externalUser_Detail(userToClientId).absolute;
  }
}

const UsersStep = (props: UserListProps) => {
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const onChange = async (newUserToClients: server.dto.UserToClientSmall[]) => {
    setIsModalOpen(false);
    setIsLoading(true);
    await window.CoreApi.UserToClient.SetUserToClientFreeFieldProfile({
      userToClientIds: newUserToClients.map(userToClient => userToClient.userToClientId),
      freeFieldProfileId: props.freeFieldProfileId
    });

    setIsLoading(false);
    props.onUsersChanged(newUserToClients);
  };

  const onUserDelete = async (userToClient: server.dto.UserToClientSmall) => {
    setIsLoading(true);
    const dto: server.dto.RemoveFreeFieldProfileForUserInstruction = {
      freeFieldProfileId: props.freeFieldProfileId,
      userToClientId: userToClient.userToClientId
    };

    await window.CoreApi.FreeFieldProfile.RemoveFreeFieldProfileForUser(dto);

    const userToClients = await window.CoreApi.FreeFieldProfile.ListUserToClientsByProfile(props.freeFieldProfileId);
    if (userToClients.data.hasErrors) {
      return;
    }
    setIsLoading(false);
    props.onUsersChanged(userToClients.data.data);
  };

  return (
    <>
      {isModalOpen && <MultiUserToClientModalPicker
        customLabel={RESX.SoUser.AssignUsers}
        environment={props.environment}
        onChange={onChange}
        value={props.userToClients}
        required={false}
        inPageEditing={{ cancel: () => setIsModalOpen(false) }}
        canCreateNew={false}
        validatorKey="userToClientFreeFieldProfileAssignment"
      />}
      <div className="flex justify-end">
        <ButtonSecondary onClick={() => setIsModalOpen(true)} label={RESX.SoUser.AssignUsers} />
      </div>
      <Table
        variant="cards"
        canDelete={() => true}
        onDelete={onUserDelete}
        items={isLoading ? [] : props.userToClients}
        isLoading={isLoading}
        getKey={user => user.userToClientId.toString()}
        hideHeader
        columns={[{
          key: "avatar",
          header: "",
          render: (user) => <UserAvatar user={user.user} size="avatar-30" />,
          size: "auto"
        }, {
          key: "name",
          header: "",
          render: (user) => <a href={userDetailPage(props.environment, user.userToClientId)}>{user.user.fullName}</a>,
          size: "1fr"
        }]}
      />
    </>
  );
};

export default UsersStep;
